import { isNil , and } from 'ramda';
import { Component, ElementRef, HostListener, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Location } from '@angular/common';

import { ContainerDirective } from '@app/directives/container/container.directive';
import { AuthService } from '@app/gateway/services/auth.service';
import { IdleService } from '@app/services/idle/idle.service';
import { StateService } from '@app/services/state/state.service';
import { StorageService } from '@app/services/storage/storage.service';
import { NotificationsService, ErrorsToken } from './services/notification/notification.service';
import { Notifications } from './models/partials.model';
import { TranslateService } from "@ngx-translate/core";
import { debounceTime, delay, distinctUntilChanged, filter, map, switchMap } from "rxjs/operators";

import { NavigationEnd, Router } from '@angular/router';
import { CreateAccountService } from 'app/gateway/services/createAccount.service';
import { PeopleFacade } from './state/people/people.facade';
import { JoyrideService } from 'ngx-joyride';
import { ApiService } from './gateway/services/api.service';
import { SigninService } from './gateway/signin/signin.service';
import { ServiceConfigService } from './services/service-config.service';
import { Title } from '@angular/platform-browser';
import { isPartner } from '@app/helpers/mode.helpers';
import { UserProfileService } from "../app/gateway/user-profile/user-profile.service";
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';

declare let gtag: Function;
@Component({
    selector: 'nh-root',
    templateUrl: './app.component.html',
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(ContainerDirective, { static: true })
  top: ContainerDirective;
  @ViewChild('mainContent') mainContent: ElementRef<HTMLElement>;
  notifications: Observable<Notifications>;
  identifier$ = this.state.identifier$;
  title$: Observable<string>;
  secondTitle$: Observable<string> = of('Getting Health Care with TennCare');
  sidebarOpened = false;
  isOnApp = false;
  isStepper = true;
  isAppNum = true;
  isPartner;
  isSummary$ = this.createAccountService.getIsSummary().pipe(delay(0));
  isSummaryNew$:boolean;
  isHHTJF = false;
  isHHIND = false;
  blockTitle: string;
  isStartPage: boolean;
  isPresumptive = false;
  appType;
  userType;
  isMobileProgBarOpen = false;
  isSUSIG = false;
  isSUPSM = false;
  rmbTitle;
  screenHeight: number;
  screenWidth: number;
  isMobileView: boolean;
  mobileWidth = 480;
  isSiteWideAlertEnabled: boolean;
  isPPRenewalAlertEnabled: boolean;
  isPPDDARenewalAlertEnabled: boolean;
  isPPDentalBannerSwitchEnabled: boolean;
  siteWideText: string;
  renewalText: string;
  renewalPPText: string;
  enSiteWideAlert: string;
  enRenewalAlert: string;
  spRenewalAlert: string;
  enRenewalPPAlert: string;
  ppDdaBannerMessage: string;
  spRenewalPPAlert: string;
  dentalBenefitsText: string;
  dentalBenefitsPPText: string;
  enPartnerDentalBenefitsAlert: string;
  spPartnerDentalBenefitsAlert: string;
  enDentalBenefitsAlert: string;
  spDentalBenefitsAlert: string;
  spSiteWideAlert: string;
  isSubTitleEnabled$: Observable<boolean>;  
  isEnvironmentAlertEnabled: boolean;
  isDentalBannerSwitchEnabled: boolean;
  isMasterBannerSwitchEnabled: boolean;
  mpMaintenanceBannerStartTime: string;
  mpMaintenanceBannerEndTime: string;
  mpMaintenanceBanner: boolean = false;
  private maintenanceCheckInterval: any;
  environmentAlertText: string;
  environmentName: string;
  isBCCEXT = sessionStorage.getItem('appType') === 'BXT';
  isIME = sessionStorage.getItem('appType') === 'IME';
  ppDental = this.serverConfig.getServerConfig().isPPDentalBannerSwitchEnabled;
  renewalPPAlertSwitch = this.serverConfig.getServerConfig().renewalPPAlertSwitch;
  sitewidePPSwitch = this.serverConfig.getServerConfig().isSiteWidePPAlertEnabled;
  siteWideMasterSwitch;
  mobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  mobileSitewideAlertKeys: string[] = [];
  desktopSitewideAlertKeys: string[] = [];
  mobileSitewideAlertIndex = 0;
  desktopSitewideAlertIndex = 0;
  bannerRevampSwitch = this.serverConfig.getServerConfig().bannerRevampSwitch;
  maintenanceBannerAutoRemovalSwitch = this.serverConfig.getServerConfig().maintenanceBannerAutoRemovalSwitch;
  tccGetMobileAppSwitch = this.serverConfig.getServerConfig().tccGetMobileAppSwitch;
  onHomeScreen = sessionStorage.getItem('homeScreen') === 'true' ? true : false;
  private safariOnHomeScreen = window.location.pathname === '/' || window.location.pathname === '';
  isScrolledDown = false;
  private scrollListener: (() => void) | null = null;
  private scrollContainer: Element | null = null;
  private safariMetaTag: HTMLMetaElement | null = null;
  previousUrl: string | null = null;
  currentUrl: string | null = null;
  private readonly appPopupChannelName = 'tccAppPopupChannel';
  private readonly appPopupWindowIdKey = 'tccAppPopupWindowId';
  private readonly appPopupWindowId = this.getAppPopupWindowId();
  private appPopupChannel: BroadcastChannel | null = null;

  constructor(
    private idle: IdleService,
    private state: StateService,
    private authService: AuthService,
    public translateService: TranslateService,
    private router: Router,
    private location: Location,
    private createAccountService: CreateAccountService,
    private people: PeopleFacade,
    private readonly joyrideService: JoyrideService,
    public apiService: ApiService,
    public storageService: StorageService,
    private signinService: SigninService,
    private serverConfig: ServiceConfigService,
    private titleService: Title,
    private userProfileService: UserProfileService,
    private analytics: GoogleAnalyticsService,
    @Inject(ErrorsToken) private notify: NotificationsService
  ) {
    this.signinService.userLoggedIn.subscribe((res) => {
      if (res) {
        this.idle.start();
      } else {
        this.isAppNum = false;
        this.isOnApp = false;
      }

      const translateLang = sessionStorage.getItem('currentLang');
      if(translateLang){
        this.translateService.setDefaultLang(translateLang);
      }
      
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const wasOnHomeScreen = this.safariOnHomeScreen;
        this.onHomeScreen = event.urlAfterRedirects === '/' || event.urlAfterRedirects === '';
        this.safariOnHomeScreen = this.onHomeScreen;
        this.updateSafariSmartBanner();

        // On Safari, reload only when leaving home screen so the smart app banner is hidden on the next page
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const leavingHome = wasOnHomeScreen && !this.safariOnHomeScreen;
        const fromSigninScreen = sessionStorage.getItem('fromSignInscreen') === 'true';
        if (this.tccGetMobileAppSwitch && isSafari && (leavingHome || (fromSigninScreen && this.onHomeScreen))) {
          sessionStorage.removeItem('fromSignInscreen');
          window.location.reload();
          return;
        }
        const getAppType = sessionStorage.getItem('appType')
        this.appType = sessionStorage.getItem('appType');
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;

        gtag('config', 'UA-118572218-43', { page_path: event.urlAfterRedirects})
        gtag('config', 'G-3CWERHG4JP', { page_path: event.urlAfterRedirects, previous_url: this.previousUrl, current_url: this.currentUrl})
        gtag('config', 'AW-686185300', { page_path: event.urlAfterRedirects })
        if (getAppType === 'APL') {
          if(event.url === "/user-profile/my-appeals") {
            this.isOnApp = false;
            sessionStorage.removeItem('appType')
          }
        };
    }

      this.siteWideMasterSwitch = this.showPPBannerMessage() && this.sitewidePPSwitch;
      this.isPPRenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch;
      this.isPPDentalBannerSwitchEnabled = this.showPPBannerMessage() && this.ppDental;
      this.isPPDDARenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch && (this.ppDdaBannerMessage && this.ppDdaBannerMessage !== "");
    });
    this.isSiteWideAlertEnabled = this.serverConfig.getServerConfig().isSiteWideAlertEnabled;
    this.isMasterBannerSwitchEnabled = this.serverConfig.getServerConfig().isMasterBannerSwitchEnabled;
    this.isPPRenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch ;
    this.isEnvironmentAlertEnabled = this.serverConfig.getServerConfig().isEnvironmentAlertEnabled;
    this.isDentalBannerSwitchEnabled = this.serverConfig.getServerConfig().isDentalBannerSwitchEnabled;
    this.isPPDentalBannerSwitchEnabled = this.showPPBannerMessage() && this.ppDental;
    this.siteWideMasterSwitch = this.showPPBannerMessage() && this.sitewidePPSwitch;
    this.environmentName = this.serverConfig.getServerConfig().environmentName;
    this.enSiteWideAlert = this.serverConfig.getServerConfig().enSiteWideAlert;
    this.spSiteWideAlert = this.serverConfig.getServerConfig().spSiteWideAlert;
    this.mpMaintenanceBannerStartTime = this.serverConfig.getServerConfig().maintenanceBannerStartTime;
    this.mpMaintenanceBannerEndTime = this.serverConfig.getServerConfig().maintenanceBannerEndTime;
    this.enRenewalAlert = this.serverConfig.getServerConfig().enRenewalAlert;
    this.spRenewalAlert = this.serverConfig.getServerConfig().spRenewalAlert;
    this.enRenewalPPAlert = this.serverConfig.getServerConfig().enRenewalPPAlert;
    this.spRenewalPPAlert = this.serverConfig.getServerConfig().spRenewalPPAlert;
    this.enDentalBenefitsAlert = this.serverConfig.getServerConfig().enDentalBenefitsAlert;
    this.spDentalBenefitsAlert = this.serverConfig.getServerConfig().spDentalBenefitsAlert;
    this.enPartnerDentalBenefitsAlert = this.serverConfig.getServerConfig().enPartnerDentalBenefitsAlert;
    this.spPartnerDentalBenefitsAlert = this.serverConfig.getServerConfig().spPartnerDentalBenefitsAlert;
    const enEnvironmentAlertText = this.serverConfig.getServerConfig().enEnvironmentAlertText;
    const spEnvironmentAlertText = this.serverConfig.getServerConfig().spEnvironmentAlertText;
    const enPartnerSiteWideAlert = this.serverConfig.getServerConfig().enPartnerSiteWideAlert;
    const spPartnerSiteWideAlert = this.serverConfig.getServerConfig().spPartnerSiteWideAlert;
   // const ppAccess = ["PRG", "BCC", "HPE", "TCA", "NBN", "ADF", "LOC", "TCC", "KPU"];
    this.ppDdaBannerMessage = this.serverConfig.getServerConfig().PP_DDA_BannerMessage;

    const appNum = sessionStorage.getItem('appNum');
    this.appType = sessionStorage.getItem('appType');
    this.userType = sessionStorage.getItem('userType');
    //const isKepro = JSON.parse(sessionStorage.getItem('isKepro'));
    this.isPartner = isPartner(this.userType);
    this.isPresumptive = this.appType === 'HPE' || this.appType === 'PRG' || this.appType === 'BCC';
    this.notifications = this.notify?.list;
    //const hasPPAccess = ppAccess.includes(this.appType);

    if (this.translateService.getDefaultLang() === "sp") {
      this.siteWideMasterSwitch = this.showPPBannerMessage() && this.sitewidePPSwitch && (spPartnerSiteWideAlert !== null || this.spSiteWideAlert !== null);
      this.siteWideText = this.isPartner ? spPartnerSiteWideAlert : this.spSiteWideAlert;
      this.isPPRenewalAlertEnabled = this.showPPBannerMessage()  && this.renewalPPAlertSwitch && (this.spRenewalPPAlert && this.spRenewalPPAlert !== "");
      this.isPPDentalBannerSwitchEnabled = this.showPPBannerMessage()  && this.ppDental && (this.spPartnerDentalBenefitsAlert && this.spPartnerDentalBenefitsAlert !== "");
      this.environmentAlertText = spEnvironmentAlertText;
      this.renewalText = this.spRenewalAlert;
      this.renewalPPText = this.showPPBannerMessage() ? this.spRenewalPPAlert : "";
      this.dentalBenefitsPPText = this.showPPBannerMessage() ? this.spPartnerDentalBenefitsAlert : "";
      this.dentalBenefitsText = this.spDentalBenefitsAlert;
    } else {
      this.siteWideMasterSwitch = this.showPPBannerMessage() && this.sitewidePPSwitch && (enPartnerSiteWideAlert !== null || this.enSiteWideAlert !== null);
      this.siteWideText = this.isPartner ? enPartnerSiteWideAlert : this.enSiteWideAlert;
      this.isPPRenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch && (this.enRenewalPPAlert && this.enRenewalPPAlert !== "");
      this.isPPDentalBannerSwitchEnabled = this.showPPBannerMessage() && this.ppDental && (this.enPartnerDentalBenefitsAlert && this.enPartnerDentalBenefitsAlert !== "");
      this.environmentAlertText = enEnvironmentAlertText;
      this.renewalText = this.enRenewalAlert;
      this.renewalPPText = this.showPPBannerMessage() ? this.enRenewalPPAlert : "";
      this.dentalBenefitsPPText = this.showPPBannerMessage() ? this.enPartnerDentalBenefitsAlert : "";
      this.dentalBenefitsText = this.enDentalBenefitsAlert;
    }
    this.translateService.onDefaultLangChange.subscribe((resLang) => {
      if (resLang.lang === "sp") {
        this.siteWideMasterSwitch = this.showPPBannerMessage() && this.sitewidePPSwitch && (spPartnerSiteWideAlert !== null || this.spSiteWideAlert !== null);
        this.siteWideText = this.isPartner ? spPartnerSiteWideAlert : this.spSiteWideAlert;
        this.isPPRenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch && (this.spRenewalPPAlert && this.spRenewalPPAlert !== "");
        this.isPPDentalBannerSwitchEnabled = this.showPPBannerMessage() && this.ppDental && (this.spPartnerDentalBenefitsAlert && this.spPartnerDentalBenefitsAlert !== "");
        this.environmentAlertText = spEnvironmentAlertText;
        this.renewalText = this.spRenewalAlert;
        this.renewalPPText = this.showPPBannerMessage() ? this.spRenewalPPAlert : "";
        this.dentalBenefitsPPText = this.showPPBannerMessage() ? this.spPartnerDentalBenefitsAlert : "";
        this.dentalBenefitsText = this.spDentalBenefitsAlert;
      } else {
        this.siteWideMasterSwitch = this.showPPBannerMessage() && this.sitewidePPSwitch && (enPartnerSiteWideAlert !== null || this.enSiteWideAlert !== null);;
        this.siteWideText = this.isPartner ? enPartnerSiteWideAlert : this.enSiteWideAlert;
        this.isPPRenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch && (this.enRenewalPPAlert && this.enRenewalPPAlert !== "");
        this.isPPDentalBannerSwitchEnabled = this.showPPBannerMessage() && this.ppDental && (this.enPartnerDentalBenefitsAlert && this.enPartnerDentalBenefitsAlert !== "");
        this.environmentAlertText = enEnvironmentAlertText;
        this.renewalText = this.enRenewalAlert;
        this.renewalPPText = this.showPPBannerMessage() ? this.enRenewalPPAlert : "";
        this.dentalBenefitsPPText = this.showPPBannerMessage() ? this.enPartnerDentalBenefitsAlert : "";
        this.dentalBenefitsText = this.enDentalBenefitsAlert; 
      }
      this.refreshSitewideAlertPagination();
      let allOptions = document.getElementsByTagName('option');
      for (let i = 0; i < allOptions.length; i++) {
        if (resLang.lang === "en" && allOptions[i].text == 'Elija una opción') {
          allOptions[i].text = 'Pick an option';

        }
        else if (resLang.lang === "sp" && allOptions[i].text == 'Pick an option') {
          allOptions[i].text = 'Elija una opción';

        }
      }

    })
    this.router.events.subscribe(() => {
      if (!this.location.path().includes('create-account-new/details') && sessionStorage.getItem('userData')) {
        this.createAccountService.remove()
      }
      if (appNum && this.location.path().includes(appNum)) {
        this.isAppNum = true;
      }
      this. isBCCEXT = sessionStorage.getItem('appType') === 'BXT'
      if(this.isBCCEXT && this.location.path().includes("/api/prov/atglance?")) {
        this.isOnApp = false;
        sessionStorage.removeItem('appType')
    }
    this.isIME = sessionStorage.getItem('appType') === 'IME';
    if(this.isIME && this.location.path().includes("/api/prov/atglance?")) {
      this.isOnApp = false;
      sessionStorage.removeItem('appType')
  }
    this.screenWidth = window.innerWidth;
    this.isMobileView = this.screenWidth <= this.mobileWidth;
    if(this.isMobileView && this.mobileUser && this.location.path().includes("/congrats/")){
      this.isOnApp = false;
    }
    this.refreshSitewideAlertPagination();
    });
    this.state.identifier$.subscribe(res => this.isOnApp = !isNil(res));
    this.idle.isSessionExpired$.subscribe(res => this.isOnApp = !res);
    this.state.saveAndExit$.subscribe(res => {
      if (res) {
        this.mobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
        this.userType = sessionStorage.getItem('userType');
        if (this.userType === 'RP') {
          this.router.navigateByUrl('api/prov/atglance?entityId=' + this.apiService.getEntityId()).then(() => {
            this.isOnApp = false;
            this.isAppNum = false;
          })
        } else if(this.mobileUser) {
          const caseNumber = sessionStorage.getItem('caseNum') ? sessionStorage.getItem('caseNum') : null;
          this.isOnApp = false;
          this.isAppNum = false;
          const isAFb = sessionStorage.getItem('appType') === 'AFB';
          if (isAFb) {
            this.router.navigateByUrl("start/welcomeback");
          } else {
            this.router.navigateByUrl('/renewMyBenefit?caseNumber=' + caseNumber)
          }
        } else {
          this.router.navigate(['/user-profile']).then(() => {
            this.isOnApp = false;
            this.isAppNum = false;
          })
        }
      }
    })
    this.state.continueApp$.subscribe(res => this.isAppNum = res);

    this.title$ = this.state.title$.pipe(switchMap((res: string) => {
      return this.people.activeBlock$.pipe(map(blockresult => [res, blockresult]))
    })).pipe(switchMap((res) => {
      return this.createAccountService.getIsSummary().pipe(map(resp => [res[0], res[1], resp]))
    })).pipe(switchMap((res) => {
      return this.state.identifier$.pipe(map(resp => [res[0], res[1], res[2], resp]))
    })).pipe(debounceTime(0), distinctUntilChanged()).pipe(switchMap((res: any) => {
      let title: string = res[0];
      const isKepro = JSON.parse(sessionStorage.getItem('isKepro'));
      let isFinReassessment;
      let isPreterm = sessionStorage.getItem('isPreterm') === "PRETERM" && (sessionStorage.getItem('appType') === 'RB' || (sessionStorage.getItem('appType') === 'REDETERMINATION'  && sessionStorage.getItem('isKepro') === "true"));
      const applicationType = createAccountService.sessionStorage.appType;
      if (!isNil(createAccountService.sessionStorage.isReassessment)) {
        isFinReassessment = JSON.parse(createAccountService.sessionStorage.isReassessment)
      }
      if (res[3] === 'HHTJF') {
        if (!res[2]) {
          switch (res[1] ?.identifier ?.recordId) {
            case 'taxfiling':
              title = 'Tax Filing';
              break;
            case 'taxdeductions':
              title = 'Tax Deductions';
              break;
            case 'taxdependoutside':
              title = 'Tax Dependents Outside Household';
              break;
            case 'jointfileroutside':
              title = 'Joint Filer Outside Household';
              break;
            case 'taxfileroutside':
              title = 'Tax Filer Outside Household';
              break;
          };
        } else {
          title = 'Tax Information';
        }
      }

      if (res[1] ?.identifier ?.sectionId === 'HHIND') {  
        title = 'People in Your Home';
        if (res[1] ?.identifier ?.recordId === 'additional') {
          title = res[2] ? 'People in Your Home' : 'Additional Details';
        } else if (res[1] ?.identifier ?.recordId === 'immigration') {
          title = res[2] ? 'People in Your Home' : 'Immigration';
        }
      } else if (!res[1] ?.identifier && res[3] === 'HHIND' && !sessionStorage.getItem('isAddingPerson')) {
        title = res[2] ? 'People in Your Home' : 'Immigration';
      } else if (!res[1] ?.identifier && res[3] === 'HHIND' && JSON.parse(sessionStorage.getItem('isAddingPerson'))) {
        title = 'People in Your Home';
        if (this.isSummaryNew$) {
          sessionStorage.removeItem('isAddingPerson');
        }
      }

      if (isFinReassessment) {
        if ((res[0] === 'Sign Your Application' || res[0] === 'Sign Your Renewal')) {
          title = 'Signing Your Financial Reassessment for Medicaid Coverage';
        } else if ((res[0] === 'Application Summary')) {
          title = 'Financial Reassessment Summary';
        }
      } else if (isPreterm) {
        if ((res[0] === 'Sign Your Application' || res[0] === 'Sign Your Renewal')) {
          title = 'Sign Your Questions for Review';
        } else if ((res[0] === 'Application Summary') || (res[0]=== 'Renewal Summary')) {
          title = 'Questions for Review Summary';
        }
      } else if ((applicationType === 'RC' || (applicationType === 'CHANGE_REPORT' && isKepro)) && res[0] === 'Application Summary') {
        title = 'Change Summary';
      } else if ((applicationType === 'RB' || (isKepro && applicationType === 'REDETERMINATION')) && res[0] === 'Application Summary' && !isFinReassessment && !isPreterm) {
        title = 'Renewal Summary';
      } else if(this.isBCCEXT && res[0] === 'Sign Your Application') {
        title = 'Signing the BCC Treatment Plan Extension Form';
      } else if(this.isIME && res[0] === 'Sign Your Application') {
        title = 'Signing the Incurred Medical Expense';
      }

      if (res[0] && res[0] === 'Getting Health Care with TennCare' || res[0] === 'Select Programs') {
        const defaultLanguage = this.translateService.getDefaultLang();
        const mode = sessionStorage.getItem('appType');        
        if (defaultLanguage === "en") {
          title = (applicationType === 'RB' && !isPreterm && isNil(isFinReassessment)) || (isKepro && !isPreterm && (mode === 'REDETERMINATION' || mode === 'RB')) ? 'Renew My Benefits' : applicationType === 'RC' ? 'Report My Changes' : (applicationType === 'RB' && isFinReassessment) ? 'Financial Reassessment for Institutional Medicaid Coverage' : ((applicationType === 'RB' || applicationType === 'REDETERMINATION') && isPreterm) ? 'Complete Questions for Review' : 'Apply For Coverage';
        } else {
          title = (applicationType === 'RB' && !isPreterm) ? 'Renovar mis beneficios' : applicationType === 'RC' ? 'Reportar mis cambios.' : ((applicationType === 'RB' || applicationType === 'REDETERMINATION') && isPreterm) ? 'Complete las Preguntas para la Revisión' :'Solicitar cobertura';
        }
      }

      if (res[0] && res[0] === 'Sign Your Application' && !isPreterm) {
        if ((applicationType === 'RB'|| (applicationType === 'RENEW_BENEFITS' && isKepro)) && !isFinReassessment) {
          title = 'Sign Your Renewal'
        } else if (applicationType === 'RC' || (applicationType === 'CHANGE_REPORT' && isKepro)) {
          title = 'Sign Your Change'
        }
      }

      if (res[0] && res[0] === 'Before You Begin') {
        if ((applicationType === 'RB'|| (applicationType === 'RENEW_BENEFITS' && isKepro)) && !isFinReassessment && !isPreterm) {
          title = 'Renew My Benefits'
        } else if (isFinReassessment) {
          title = 'Financial Reassessment for Institutional Medicaid Coverage'
        } else if(isPreterm) {
          title = 'Complete Questions for Review'
        }
      }

      return of(title);
    })).pipe(switchMap((res) => {
      return this.state.title$.pipe(map(result => {
        let title = res;
        if (result == null) {
          title = null;
        }
        return title;
      }))
    })).pipe(delay(0));

    this.createAccountService.getIsStartPage().subscribe(res => this.isHHTJF = res);
    // tslint:disable-next-line: no-unused-expression
    typeof (this.joyrideService);
    this.createAccountService.getIsStepperOn().subscribe(res => this.isOnApp = res);
  }

  ngOnInit() {
    this.initializeAppPopupChannel();

    this.createAccountService.getIsSummary().subscribe((res:any)=>{
      this.isSummaryNew$ = res;
    })
    
    // Re-establish GA user identification on every page load 
    // (for location.reload() happening on every global translation)
    const userId = sessionStorage.getItem('userName');
    if ((userId && userId.trim() !== '' && userId !== 'null' && userId !== 'undefined') && !this.analytics.isUserIdSet()) {
      this.analytics.setCurrentUser(userId);
    }
    
    // Re-start idle service after page reload if user is already logged in
    // This fixes session expiration after global translation (which does location.reload()) or any page reload of screens
    if (this.isLoggedIn()) {
      this.signinService.userLoggedIn.next(true);
    }
    
    // Set HTML lang attribute based on stored language preference for screen readers
    const storedLang = sessionStorage.getItem('globalTranslatedLan');
    const currentLang = sessionStorage.getItem('currentLang');
    if (storedLang && storedLang !== 'undefined') {
      document.documentElement.lang = storedLang;
    } else if (currentLang === 'sp') {
      document.documentElement.lang = 'es';
    } else {
      document.documentElement.lang = 'en';
    }
    
    // this.metaService.createCanonicalURL();
    this.isSubTitleEnabled$ = this.state.blockLinks$.pipe(map((res) => {
      return (res ? (res.length <= 0) : true);
    })).pipe(delay(0));

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router)
    ).subscribe(() => {
      const title = this.getTitle(this.router.routerState, this.router.routerState.root).join(' | ');
      this.titleService.setTitle(title);
      if (document.querySelector('.mat-sidenav-content')) {
      document.querySelector('.mat-sidenav-content').scrollTop = 0;
      }
      window.scrollTo(0, 0);
    });

    this.userProfileService.fomMobileApp$.subscribe((bool) => {
      if(sessionStorage.getItem('isMobileUser') === 'true') {
        this.mobileUser = true;
      } else {
        this.mobileUser = bool;
      }
    });
    const originalLang = document.documentElement.lang;
    const observer = new MutationObserver(() => {
      const currentLang = document.documentElement.lang;
      if (currentLang !== originalLang) {
        this.sendTranslateEventToGA(currentLang);
      }
    })
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] })
    this.userProfileService.showDDABannerMessage$.subscribe((bool) => {
      this.isPPDDARenewalAlertEnabled = this.showPPBannerMessage() && this.renewalPPAlertSwitch && (this.ppDdaBannerMessage && this.ppDdaBannerMessage !== "");
      if(bool && this.showPPBannerMessage()) {
        this.isPPRenewalAlertEnabled = false;
        this.renewalPPText= this.ppDdaBannerMessage
      }
      this.refreshSitewideAlertPagination();
    })

    // Set up interval to check maintenance banner status every minute
    this.updateMaintenanceBannerStatus();
    this.maintenanceCheckInterval = setInterval(() => {
      this.updateMaintenanceBannerStatus();
    }, 100); // Check every 0.1 seconds

    this.refreshSitewideAlertPagination();
  }

  private setupScrollListener(): void {
    this.scrollListener = () => {
      if (!this.safariOnHomeScreen) {
        return;
      }
      const scrollTop = this.scrollContainer ? this.scrollContainer.scrollTop : window.scrollY;
      const scrolled = scrollTop > 50;
      if (scrolled !== this.isScrolledDown) {
        this.isScrolledDown = scrolled;
        this.updateSafariSmartBanner();
      }
    };
    // Use native window scroll so Safari's smart app banner auto-hides on scroll
    this.scrollContainer = null;
    window.addEventListener('scroll', this.scrollListener, { passive: true } as any);
  }

  updateMaintenanceBannerStatus(): void {
    this.mpMaintenanceBanner = this.maintenanceBannerAutoRemovalSwitch ? this.getMaintenanceBannerStatus(
      this.mpMaintenanceBannerStartTime, 
      this.mpMaintenanceBannerEndTime
    ) : true;
    this.refreshSitewideAlertPagination();
  }

  private refreshSitewideAlertPagination(): void {
    const mobileAlerts: string[] = [];
    const desktopAlerts: string[] = [];

    if (!this.isMasterBannerSwitchEnabled) {
      this.mobileSitewideAlertKeys = mobileAlerts;
      this.desktopSitewideAlertKeys = desktopAlerts;
      this.mobileSitewideAlertIndex = 0;
      this.desktopSitewideAlertIndex = 0;
      return;
    }

    if (this.showMobileSiteWideAlert()) {
      mobileAlerts.push('siteWide');
    }
    if (this.showDesktopSiteWideAlert()) {
      desktopAlerts.push('siteWide');
    }

    if (this.showMobileSiteWideMasterAlert()) {
      mobileAlerts.push('siteWideMaster');
    }
    if (this.showDesktopSiteWideMasterAlert()) {
      desktopAlerts.push('siteWideMaster');
    }

    if (this.showMobileRenewalAlert()) {
      mobileAlerts.push('renewal');
    }
    if (this.showDesktopRenewalAlert()) {
      desktopAlerts.push('renewal');
    }

    if (this.showMobileRenewalPPAlert()) {
      mobileAlerts.push('renewalPP');
    }
    if (this.showDesktopRenewalPPAlert()) {
      desktopAlerts.push('renewalPP');
    }

    if (this.showMobileDentalPPAlert()) {
      mobileAlerts.push('dentalPP');
    }
    if (this.showDesktopDentalPPAlert()) {
      desktopAlerts.push('dentalPP');
    }

    if (this.showMobileDentalAlert()) {
      mobileAlerts.push('dental');
    }

    if (this.showDesktopDentalAlert()) {
      desktopAlerts.push('dental');
    }

    this.mobileSitewideAlertKeys = mobileAlerts;
    this.desktopSitewideAlertKeys = desktopAlerts;
    this.mobileSitewideAlertIndex = this.clampSitewideAlertIndex(this.mobileSitewideAlertIndex, mobileAlerts.length);
    this.desktopSitewideAlertIndex = this.clampSitewideAlertIndex(this.desktopSitewideAlertIndex, desktopAlerts.length);
  }

  showMobileSiteWideAlert(): boolean {
    return !this.isPartner && this.isSiteWideAlertEnabled && this.enableBannerMessage() && this.mpMaintenanceBanner;
  }

  showDesktopSiteWideAlert(): boolean {
    return !this.isPartner && this.isSiteWideAlertEnabled && this.enableBannerMessage() && this.mpMaintenanceBanner;
  }

  showMobileSiteWideMasterAlert(): boolean {
    return this.siteWideMasterSwitch && this.mpMaintenanceBanner;
  }

  showDesktopSiteWideMasterAlert(): boolean {
    return this.siteWideMasterSwitch && this.mpMaintenanceBanner;
  }

  showMobileRenewalAlert(): boolean {
    return !this.isPartner && !this.isLoggedIn() && this.enableBannerMessage() && !!this.renewalText;
  }

  showDesktopRenewalAlert(): boolean {
    return !this.isPartner && !this.isLoggedIn() && this.enableBannerMessage() && !!this.renewalText;
  }

  showMobileRenewalPPAlert(): boolean {
    return (this.isPPRenewalAlertEnabled || this.isPPDDARenewalAlertEnabled) && !!this.renewalPPText;
  }

  showDesktopRenewalPPAlert(): boolean {
    return (this.isPPRenewalAlertEnabled || this.isPPDDARenewalAlertEnabled) && !!this.renewalPPText;
  }

  showMobileDentalPPAlert(): boolean {
    return this.isPPDentalBannerSwitchEnabled;
  }

  showDesktopDentalPPAlert(): boolean {
    return this.isPPDentalBannerSwitchEnabled;
  }

  showMobileDentalAlert(): boolean {
    return !this.isPartner && this.isDentalBannerSwitchEnabled && this.enableBannerMessage();
  }

  showDesktopDentalAlert(): boolean {
    return !this.isPartner && !this.isLoggedIn() && this.isDentalBannerSwitchEnabled && this.enableBannerMessage();
  }

  private clampSitewideAlertIndex(index: number, length: number): number {
    if (length <= 0) {
      return 0;
    }

    if (index < 0) {
      return 0;
    }

    if (index >= length) {
      return length - 1;
    }

    return index;
  }

  get activeMobileSitewideAlertKey(): string | null {
    if (!this.mobileSitewideAlertKeys.length) {
      return null;
    }

    return this.mobileSitewideAlertKeys[this.mobileSitewideAlertIndex] || null;
  }

  get activeDesktopSitewideAlertKey(): string | null {
    if (!this.desktopSitewideAlertKeys.length) {
      return null;
    }

    return this.desktopSitewideAlertKeys[this.desktopSitewideAlertIndex] || null;
  }

  previousMobileSitewideAlert(): void {
    if (this.mobileSitewideAlertIndex > 0) {
      this.mobileSitewideAlertIndex -= 1;
    }
  }

  nextMobileSitewideAlert(): void {
    if (this.mobileSitewideAlertIndex < this.mobileSitewideAlertKeys.length - 1) {
      this.mobileSitewideAlertIndex += 1;
    }
  }

  previousDesktopSitewideAlert(): void {
    if (this.desktopSitewideAlertIndex > 0) {
      this.desktopSitewideAlertIndex -= 1;
    }
  }

  nextDesktopSitewideAlert(): void {
    if (this.desktopSitewideAlertIndex < this.desktopSitewideAlertKeys.length - 1) {
      this.desktopSitewideAlertIndex += 1;
    }
  }

  cycleMobileSitewideAlert(): void {
    if (this.mobileSitewideAlertIndex < this.mobileSitewideAlertKeys.length - 1) {
      this.nextMobileSitewideAlert();
      return;
    }

    this.previousMobileSitewideAlert();
  }

  cycleDesktopSitewideAlert(): void {
    if (this.desktopSitewideAlertIndex < this.desktopSitewideAlertKeys.length - 1) {
      this.nextDesktopSitewideAlert();
      return;
    }

    this.previousDesktopSitewideAlert();
  }

  setMobileSitewideAlertIndex(i: number): void {
    this.mobileSitewideAlertIndex = i;
  }

  setDesktopSitewideAlertIndex(i: number): void {
    this.desktopSitewideAlertIndex = i;
  }

  get isSpanishSelected(): boolean {
    return this.translateService.getDefaultLang() === 'sp';
  }

  get scheduledMaintenanceLabel(): string {
    return this.isSpanishSelected ? 'Mantenimiento programado' : 'Scheduled Maintenance';
  }

  get viewNextAlertLabel(): string {
    return this.isSpanishSelected ? 'Ver la siguiente alerta' : 'View Next Alert';
  }

  get viewPreviousAlertLabel(): string {
    return this.isSpanishSelected ? 'Ver la alerta anterior' : 'View Previous Alert';
  }

  get viewAlertLabel(): string {
    return this.isSpanishSelected ? 'Ver alerta' : 'View Alert';
  }

  get previousAlertAriaLabel(): string {
    return this.isSpanishSelected ? 'Alerta anterior' : 'Previous alert';
  }

  get nextAlertAriaLabel(): string {
    return this.isSpanishSelected ? 'Siguiente alerta' : 'Next alert';
  }

  get mobileSitewideAlertNavigationLabel(): string {
    if (this.mobileSitewideAlertIndex < this.mobileSitewideAlertKeys.length - 1) {
      return this.viewNextAlertLabel;
    }

    if (this.mobileSitewideAlertIndex > 0) {
      return this.viewPreviousAlertLabel;
    }

    return this.viewAlertLabel;
  }

  get desktopSitewideAlertNavigationLabel(): string {
    if (this.desktopSitewideAlertIndex < this.desktopSitewideAlertKeys.length - 1) {
      return this.viewNextAlertLabel;
    }

    if (this.desktopSitewideAlertIndex > 0) {
      return this.viewPreviousAlertLabel;
    }

    return this.viewAlertLabel;
  }

  ngOnDestroy(): void {
    if (this.appPopupChannel) {
      this.appPopupChannel.close();
      this.appPopupChannel = null;
    }
    // Clean up interval when component is destroyed
    if (this.maintenanceCheckInterval) {
      clearInterval(this.maintenanceCheckInterval);
    }
    // Clean up scroll listener
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = null;
      this.scrollContainer = null;
    }
    if (this.safariMetaTag && this.safariMetaTag.parentNode) {
      this.safariMetaTag.parentNode.removeChild(this.safariMetaTag);
      this.safariMetaTag = null;
    }
  }

  private initializeAppPopupChannel(): void {
    if (typeof BroadcastChannel === 'undefined') {
      return;
    }

    this.appPopupChannel = new BroadcastChannel(this.appPopupChannelName);
    this.appPopupChannel.onmessage = (event: MessageEvent) => this.handleApplicationPopupMessage(event);
  }

  private getAppPopupWindowId(): string {
    const existingWindowId = sessionStorage.getItem(this.appPopupWindowIdKey);
    if (existingWindowId) {
      return existingWindowId;
    }

    const windowId = crypto.randomUUID();
    sessionStorage.setItem(this.appPopupWindowIdKey, windowId);
    return windowId;
  }

  private handleApplicationPopupMessage(event: MessageEvent): void {
    const closeEvent = event.data;
    const currentCaseNumber = sessionStorage.getItem('caseNum');
    const currentAppType = sessionStorage.getItem('appType');
    const isPreterm = sessionStorage.getItem('isPreterm') === 'PRETERM';
    const currentApplicationFlow = currentAppType === 'CHANGE_REPORT' || currentAppType === 'RC'
      ? 'RMC'
      : isPreterm && (currentAppType === 'RB' || currentAppType === 'REDETERMINATION')
        ? 'PRETERM'
        : currentAppType === 'RB' || currentAppType === 'REDETERMINATION'
          ? 'RMB'
          : null;

    if (closeEvent?.eventName === 'APPLICATION_STARTED' &&
      closeEvent.applicationFlow === currentApplicationFlow &&
      currentApplicationFlow &&
      currentCaseNumber &&
      closeEvent.caseNumber === currentCaseNumber &&
      closeEvent.windowId !== this.appPopupWindowId) {
      window.close();
    }
  }

  private updateSafariSmartBanner(): void {
    if (this.tccGetMobileAppSwitch && this.onHomeScreen && !this.isScrolledDown) {
      // Add meta tag if not already present
      if (!this.safariMetaTag) {
        this.safariMetaTag = document.createElement('meta');
        this.safariMetaTag.name = 'apple-itunes-app';
        let deepLinkUrl = this.serverConfig.getServerConfig().tccMobileAppDeepLink || '';
        if (deepLinkUrl) {
          const url = new URL(deepLinkUrl);
          ['utm_campaign', 'utm_source', 'utm_medium'].forEach(p => url?.searchParams?.delete(p));
          deepLinkUrl = url.toString();
        }
        this.safariMetaTag.content = deepLinkUrl ? `app-id=1435791637, affiliate-data=ct=SmartBanner&pt=1844443, app-argument=${deepLinkUrl}` : 'app-id=1435791637';
        document.head.appendChild(this.safariMetaTag);
      }
    } else {
      // Remove meta tag when not on home screen or when scrolled
      if (this.safariMetaTag && this.safariMetaTag.parentNode) {
        this.safariMetaTag.parentNode.removeChild(this.safariMetaTag);
        this.safariMetaTag = null;
      }
    }
  }

  sendTranslateEventToGA(language: string) {
    if (window && gtag) {
      gtag('event', 'browserTranslate', {
        'event_category': 'Browser Translate',
        'event_label': 'Browser Translate Trigger',
        'value': language
      });
    }
  }

  ngAfterViewInit(): void {
    window.scroll(0,0);
    // Set up scroll listener here so mat-sidenav-content is guaranteed to exist in the DOM
    this.setupScrollListener();
  }

  showPPBannerMessage() {
    const url = this.router.url;
    let showPPBanner = false
    showPPBanner = url.includes("/api/prov/atglance") ? true : false;
    this.isPartner = isPartner(this.userType);
    return and(isPartner, showPPBanner);;
  }

  enableBannerMessage() {
    const url = this.router.url;
    this.isPartner = isPartner(this.userType);
    if (!this.isPartner) {
      const onHomeScreen = sessionStorage.getItem('homeScreen') === 'true';
      const homeOrSignInScreen = url.includes("/signin") || onHomeScreen ? true : false;
      return homeOrSignInScreen;
    } else {
     return this.showPPBannerMessage();
    }
  }

  isLoggedIn() {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    const userName = sessionStorage.getItem('userName');
    const getCurrentUser = !isNil(currentUser) || !isNil(userName);

    const token = this.authService.tokenId;
    const hasToken = !isNil(token);
    return and(hasToken, getCurrentUser);
  }
  
  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  onToggle(open) {
    this.sidebarOpened = open;
  }

  onSignout(_) {
    const appNum = sessionStorage.getItem('appNum');
    if (!appNum && !this.location.path().includes(appNum)) {
      this.isAppNum = false;
    }
    this.isOnApp = false;
    if (this.isAppNum === false) {
      this.idle.signOut(false);
    }
  }

  onActivate() {
    this.top?.element().scrollIntoView();
    setTimeout(() => {
      const heading = document.querySelector('h1.page-title-h1') as HTMLElement | null;
      if (heading) {
        // Hide focus outline and focus on heading
        heading.style.outline = 'none';
        heading.focus();
      } else {
        // Use ARIA live region for title announcement when no heading exists
        const announcer = document.getElementById('page-announcer');
        const pageTitle = this.titleService.getTitle() || 'Page loaded';
        if (announcer) {
          announcer.textContent = pageTitle;
          // Clear after announcement
          setTimeout(() => {
            if (announcer) announcer.textContent = '';
          }, 1000);
        }
      }
    }, 0);
  }

  onProgressBarOpen() {
    this.isMobileProgBarOpen = !this.isMobileProgBarOpen;
  }

  @HostListener('window:resize')
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  ngDoCheck() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
  }

  isSecondTitle(): boolean {
    if (sessionStorage.getItem('typesOfCoverage') === 'yes') {
      this.titleService.setTitle('Getting Health Care with TennCare');
    };
    return (sessionStorage.getItem('typesOfCoverage') && sessionStorage.getItem('typesOfCoverage') === 'yes')
  }

  getMaintenanceBannerStatus(startTime: string, endTime: string): boolean {
    if (!startTime || !endTime) {
      return false;
    }

    const timeZone = 'America/Chicago';

    const parseDateTime = (value: string): { year: number; month: number; day: number; hour: number; minute: number } | null => {
      // Supports: "MM/DD/YYYY h:mm AM/PM", "MM/DD/YYYY h AM/PM", optional trailing timezone text.
      const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)(?:\s+[A-Z]{2,4})?$/i);
      if (!match) {
        return null;
      }

      const month = Number(match[1]);
      const day = Number(match[2]);
      const year = Number(match[3]);
      const hour12 = Number(match[4]);
      const minute = Number(match[5] ?? '0');
      const period = match[6].toUpperCase();

      if (month < 1 || month > 12 || day < 1 || day > 31 || hour12 < 1 || hour12 > 12 || minute < 0 || minute > 59) {
        return null;
      }

      let hour24 = hour12 % 12;
      if (period === 'PM') {
        hour24 += 12;
      }

      return {
        year,
        month,
        day,
        hour: hour24,
        minute
      };
    };

    const getCurrentChicagoDateTime = (): { year: number; month: number; day: number; hour: number; minute: number } => {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });

      const parts = formatter.formatToParts(new Date());
      const map = {} as Record<string, string>;
      parts.forEach((part) => {
        if (part.type !== 'literal') {
          map[part.type] = part.value;
        }
      });

      return {
        year: Number(map.year),
        month: Number(map.month),
        day: Number(map.day),
        hour: Number(map.hour),
        minute: Number(map.minute)
      };
    };

    const toComparable = (value: { year: number; month: number; day: number; hour: number; minute: number }): number => {
      return Number(
        `${value.year}${String(value.month).padStart(2, '0')}${String(value.day).padStart(2, '0')}${String(value.hour).padStart(2, '0')}${String(value.minute).padStart(2, '0')}`
      );
    };

    const start = parseDateTime(startTime);
    const end = parseDateTime(endTime);

    if (!start || !end) {
      return false;
    }

    const now = getCurrentChicagoDateTime();
    const startValue = toComparable(start);
    const endValue = toComparable(end);
    const nowValue = toComparable(now);

    if (endValue >= startValue) {
      return nowValue >= startValue && nowValue < endValue;
    }

    // Handles ranges crossing midnight (for example, 11 PM to 2 AM next day).
    return nowValue >= startValue || nowValue < endValue;
  }
}